import React from 'react';
import { debounce } from 'lodash';
export const useDebounce = (fn, t = 500) => {
  const mut = React.useRef((...args) => {});
  React.useEffect(() => {
    mut.current = fn;
  }, [fn]);
  const debouncedFn = React.useCallback(debounce((...args) => mut.current?.(...args), t), []);
  return debouncedFn;
};